import styles from "./NotFoundPage.module.scss";

export function NotFoundPage() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.errorTitle}>404</h1>
        <p className={styles.subtitle}>Page not found</p>
        <a href="/" className={styles.link}>
          Go Home →
        </a>
      </div>
    </div>
  );
}
